document.addEventListener("DOMContentLoaded", function () {

  const bar = document.getElementById("zyvorStickyBar");
  if (!bar) return;

  let lastScrollY = window.scrollY;

  window.addEventListener("scroll", function () {

    const currentScrollY = window.scrollY;

    // SHOW ONLY WHEN SCROLLING DOWN
    if (currentScrollY > lastScrollY && currentScrollY > 700) {
      bar.classList.add("show");
    }

    // HIDE WHEN SCROLLING UP
    if (currentScrollY < lastScrollY) {
      bar.classList.remove("show");
    }

    lastScrollY = currentScrollY;

  });

  // =========================
  // ADD TO CART (UNCHANGED)
  // =========================
  document.querySelector("[data-add-cart]")?.addEventListener("click", function () {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.submit();
  });

  // =========================
  // BUY NOW (UNCHANGED)
  // =========================
  document.querySelector("[data-buy-now]")?.addEventListener("click", function () {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    let input = form.querySelector('input[name="return_to"]');

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "return_to";
      form.appendChild(input);
    }

    input.value = "/checkout";
    form.submit();
  });

});